import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import Partner from "./partner_details/Partner";
import Booking from "./booking_details/Booking";

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;

    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        // Auto-logout after 2 minutes of inactivity
        localStorage.removeItem("authToken"); // Clear authentication token
        navigate("/"); // Redirect to login page
      }, 2 * 60 * 1000); // 2 minutes
    };

    // Reset timeout on user activity
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimeout));

    resetTimeout(); // Initialize timeout

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => window.removeEventListener(event, resetTimeout));
    };
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/partner-details"
        element={
          <PrivateRoute>
            <Partner />
          </PrivateRoute>
        }
      />
      <Route
        path="/booking-details"
        element={
          <PrivateRoute>
            <Booking />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default AppWrapper;